var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"padding":"0px !important"}},[_c('v-container',{staticClass:"secondary",staticStyle:{"padding":"0px !important"},attrs:{"justify-ceneter":"","align-center":"","fluid":"","fill-height":""}},[_c('v-row',{style:({
					padding: '0px'
				}),attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"6","lg":"4"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }